module.exports = __webpack_public_path__ + "img/diana-miron.ece5c681.jpg";